import React from 'react';
import * as classes from './Wrapper.module.css';


const Description = (props) => {
    const styles = props.classes ? [classes.Ingredient, ...props.classes] : [classes.Ingredient];

    let ingredientStyles = [classes.Text];

    const title = <h3 className={classes.Title}>{props.caramel.name}</h3>;

    const tasting = <p className={classes.Tasting}>{props.caramel.description}</p>;

    const ingredientList = (
        <div className={ingredientStyles.join(' ')}>
            <p className={classes.Ingredients}><span className={classes.Bold}>Ingredients: </span>{props.ingredient.highlights}</p>
            {/* <p className={classes.BaseIngredients}>{props.ingredient.vegan ? baseIngredients.vegan.join(', ') : baseIngredients.main.join(', ')}</p> */}
        </div>
    )

    const ingredient = (
        <div
            className={styles.join(' ')}
        >
            {title}
            {tasting}
            {ingredientList}
        </div>
    )

    return ingredient;
};

export default Description;